export default __webpack_public_path__ + "static/media/order_canceled.fb9f061a.svg";